import "./CallToAction.css";
import { useNavigate } from "react-router-dom";

const CallToAction = () => {
  const navigate = useNavigate();
  return (
    <div className="ctaContainer">
      <h2 className="ctaTitle">Let&apos;s Make Great Products Together</h2>
      <p className="ctaText">
        Please feel free to enquire. We persist customers&apos; benefit, satisfaction, <br />
        and will prove it is worthy trying!
      </p>
      <button className="ctaButton" onClick={() => navigate('/GetInTouch')}>SURE, WHY NOT!</button>
    </div>
  );
};

export default CallToAction;